import PropTypes from 'prop-types';
import { useIntl, defineMessages } from 'dibs-react-intl';
import styles from '../../styles/main.scss';
import classNames from 'classnames';

// components
import Text from '../inputs/Text';

const messages = defineMessages({
    placeholder: {
        id: 'dc.AddressForm.LastName.placeholder',
        defaultMessage: 'Last Name*',
    },
});

const LastName = ({
    value,
    autoFocus = false,
    error,
    fieldSize,
    isBlurred,
    disabled,
    onChange,
    onBlur = () => {},
    isMobile,
}) => {
    const intl = useIntl();
    return (
        <Text
            name="lastName"
            dataTn="last-name"
            value={value}
            wrapperClass={classNames(isMobile ? styles.group : styles.right)}
            placeholder={intl.formatMessage(messages.placeholder)}
            autoComplete="family-name"
            autoFocus={autoFocus}
            fieldSize={fieldSize}
            isBlurred={isBlurred}
            disabled={disabled}
            error={error}
            onChange={onChange}
            onBlur={onBlur}
        />
    );
};

LastName.propTypes = {
    value: PropTypes.string.isRequired,
    error: PropTypes.string,
    autoFocus: PropTypes.bool,
    fieldSize: PropTypes.oneOf(['small', 'medium', 'large']),
    isBlurred: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    isMobile: PropTypes.bool,
};

export default LastName;
